import sortBy from 'lodash/sortBy';
import * as React from 'react';
import { components, OptionProps } from 'react-select';
import makeAnimated from 'react-select/animated';

import { filter } from 'rxjs/operators';
import styled from 'styled-components';
import {
  activeMetrics,
  IMetrics,
  toOptions,
} from '../../../../data/providers/metricsProvider';
import {
  ISelectableMetric,
  ISelectOption,
  ISelectOptionsMap,
} from '../../../../data/types';
import { Icon } from '../../Icon';
import { Select } from '../Select';

interface IProps {
  testTypeId: string;
  value: ISelectOption;
  disabled: boolean;
  onChange: (s: ISelectableMetric) => void;
  excludeAsymmetry?: boolean;
  onlyAsymmetry?: boolean;
  units?: string;
  id?: string;
}
const SingleMetricSelect = (props: IProps): React.ReactElement => {
  const [metrics, setMetrics] = React.useState<ISelectOptionsMap>({});

  React.useEffect((): (() => void) => {
    const listener = activeMetrics
      .pipe(filter((x: IMetrics): boolean => x && Object.keys(x).length > 0))
      .subscribe((mMetrics: IMetrics): void => {
        setMetrics(
          toOptions(
            mMetrics,
            props.excludeAsymmetry,
            props.onlyAsymmetry,
            props.units
          )
        );
      });
    return (): void => listener.unsubscribe();
  }, [props.units, props.excludeAsymmetry, props.onlyAsymmetry]);

  const sortMetrics = (opts: ISelectOption[]): ISelectOption[] =>
    sortBy(opts, (opt: ISelectOption): string => opt.label.toLowerCase());

  const { testTypeId, value, disabled } = props;

  return (
    <Select
      aria-label='key metric selector'
      options={sortMetrics(metrics[testTypeId])}
      isDisabled={disabled}
      value={value}
      controlShouldRenderValue
      placeholder='Metric...'
      components={makeAnimated({ Option: CustomOption })}
      onChange={props.onChange}
      cache={false}
      inputId={props.id ?? 'single-metric-select'}
    />
  );
};

export { SingleMetricSelect };

const CustomOption = (props: OptionProps): React.ReactElement => {
  const data = props.data as ISelectableMetric;
  return (
    <components.Option {...props}>
      <LabelWrapper>
        {data.label}
        {data.entity.direction === -1 ? (
          <Icon name='south' style={{ marginLeft: '2px' }} />
        ) : null}
      </LabelWrapper>
    </components.Option>
  );
};

const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
